import { Theming } from "@pandas/core-ui";
import type { AssessmentsData, Location, Partner, PartnerSettings } from "@pandas/http-client";
import { StateCreator } from "zustand";
import { Configuration, GlobalConfiguration } from "@/services/types";
import { Storage } from "../index";

export type InstanceInfo = {
	partner: Partner;
	location?: Location;
	partnerToken?: string;
};

export type AppConfiguration = Configuration & {
	theming: Theming;
	partnerSettings: PartnerSettings;
};

export interface ConfigSlice {
	config: AppConfiguration | null;
	globalConfig: GlobalConfiguration | null;
	configId: string | null;
	// The locationId the cached config was loaded for (null = partner-level, no location).
	// Lets consumers tell whether a cached config matches a requested location scope.
	configLocationId: string | null;
	instanceInfo: InstanceInfo | null;
	supportedAssessments: AssessmentsData | null;
	setSupportedAssessments: (supportedAssessments: AssessmentsData) => void;
	setInstanceInfo: (instanceInfo: InstanceInfo | null) => void;
	setConfig: (configId: string | null, config: AppConfiguration | null, locationId?: string | null) => void;
	setGlobalConfig: (globalConfig: GlobalConfiguration) => void;
}
const initialState = {
	config: null,
	globalConfig: null,
	configId: null,
	configLocationId: null,
	instanceInfo: null,
	supportedAssessments: null,
};
export const createConfigSlice: StateCreator<Storage, [], [], ConfigSlice> = (set) => ({
	...initialState,
	setSupportedAssessments: (supportedAssessments: AssessmentsData) =>
		set(() => ({
			supportedAssessments,
		})),
	setInstanceInfo: (instanceInfo: InstanceInfo | null) =>
		set(() => ({
			instanceInfo: instanceInfo,
		})),
	setConfig: (configId, config, locationId) => {
		return set(() => ({
			configId: configId,
			config: config,
			configLocationId: locationId ?? null,
		}));
	},
	setGlobalConfig: (globalConfig: GlobalConfiguration) =>
		set(() => ({
			globalConfig: globalConfig,
		})),
});
